export const IS_SITE_APPLICABLE_FOR_CONCESSION = 'FETCH_IS_SITE_APPLICABLE_FOR_CONCESSION';
export const CHILDREN_OVERVIEWS = 'FETCH_CHILDREN_OVERVIEWS';
export const DETAILS = 'FETCH_DETAILS';
export const IS_ON_BEHALF_OF_EMAIL = 'FETCH_IS_ON_BEHALF_OF_EMAIL';
export const CMT_SELF_SERVE_LINK = 'FETCH_CMT_SELF_SERVE_LINK';
export const IS_SITE_ON_CONCESSION = 'FETCH_IS_SITE_ON_CONCESSION';
